﻿import { tabs } from './tabs.js';
function carPricing() {
    const tabsElem = document.getElementById('car-pricing');
    const linksWithPriceDisplayQuery = document.querySelectorAll('[data-query-price-display="true"]');
    const tabSelected = function (tabs, selectedTab, targetPanelId) {
        console.log('tab selected:', selectedTab.dataset.priceDisplay);
        if (selectedTab.dataset.priceDisplay !== undefined) {
            linksWithPriceDisplayQuery.forEach((linkElem) => {
                //updateHref(linkElem, { 'price-display': selectedTab.dataset.priceDisplay });
                updateHref(linkElem, { 'priceDisplay': selectedTab.dataset.priceDisplay });
                updateEnquiryFormId(selectedTab.dataset.priceDisplay);
            });
        }
    }
    //if (tabsElem) {
    const tabsInstance = tabsElem == undefined ? null
        : tabs(tabsElem, {
            tabSelector: '[role="tab"][data-tab-pricing]',
            tabPanelSelector: '[role="tabpanel"][data-content-pricing]',
            callback: tabSelected
        });
    //}

    function updateHref(linkElem, newParams) {
        if (!linkElem.href) return;
        let url = new URL(linkElem.href);
        Object.keys(newParams).forEach(key => url.searchParams.set(key, newParams[key]));
        linkElem.href = url.toString();
    }
    function updateEnquiryFormId(selectedPriceType) {
        const enquiryForm = document.querySelector('[data-form-enquiry]');
        if (!enquiryForm) return;
        if (selectedPriceType == 'sale') {
            enquiryForm.id = 'buy-enquiry-form';
        } else if (selectedPriceType == 'lease') {
            enquiryForm.id = 'lease-enquiry-form';
        }
    }

    return {
        tabs: tabsInstance,
        callback: tabSelected
    }
}
//document.addEventListener('DOMContentLoaded', init);
export { carPricing };